import { DEFAULT_PAGE_SIZE } from "@constants";
import { axiosRequest } from "../axios.config";

const courseAPI = {
  getAllCourse: async () => {
    const url = "Course/Get-all";
    const response = await axiosRequest.get(url);
    return response;
  },
  exploreCourse: async (params) => {
    const url = "Course/Get-all-course";
    const response = await axiosRequest.get(url, { params });
    return response;
  },
  getAllCourseByInstructor: async (params) => {
    const url = "Course/Get-all-course";
    const response = await axiosRequest.get(url, { params });
    return response;
  },
  updateCourse: async (params) => {
    const course = params;
    const url = `Course/?id=${course.id}`;
    const response = await axiosRequest.put(url, course);
    return response;
  },
  changeCourseStatus: async (params) => {
    const [courseId, status] = params.data;
    const url = "Course/update-status";
    const response = await axiosRequest.put(url, { courseId, status });
    return response;
  },
  createCourse: async (params) => {
    const course = params;
    const url = "Course";
    const response = await axiosRequest.post(url, course);
    return response;
  },
  deleteCourse: async (courseId) => {
    const url = `Course?id=${courseId}`;
    const response = await axiosRequest.delete(url);
    return response;
  },
  getDetailsCourse: async (courseId) => {
    const url = `course?id=${courseId}`;
    const response = await axiosRequest.get(url);
    return response;
  },
  getCourseForLearning: async (courseId) => {
    const url = `course?id=${courseId}`;
    const response = await axiosRequest.get(url);
    return response;
  },
  // Saved courses
  getSavedCourses: async (pageNumber = 1) => {
    const url = "SavedCourses/Get-all-saved-courses";
    const config = { params: { pageNumber, pageSize: DEFAULT_PAGE_SIZE } };
    const response = await axiosRequest.get(url, config);
    return response;
  },
  saveCourse: async (courseId) => {
    const url = `SavedCourses?courseId=${courseId}`;
    const response = await axiosRequest.post(url);
    return response;
  },
  deleteSavedCourse: async (courseId) => {
    const url = `SavedCourses?courseId=${courseId}`;
    const response = await axiosRequest.delete(url);
    return response;
  },
  deleteAllSavedCourses: async () => {
    const url = "SavedCourses/remove-all";
    const response = await axiosRequest.delete(url);
    return response;
  },
  checkSavedCourse: async (courseId) => {
    const url = "SavedCourses/is-saved-courses";
    const config = { params: { courseId } };
    const response = await axiosRequest.get(url, config);
    return response;
  },
  // Lecture completion
  markLessonCompleted: async (lectureId) => {
    const url = "LectureCompletion";
    const response = await axiosRequest.post(url, { lectureId });
    return response;
  },
  markQuizCompleted: async (quizId) => {
    const url = "QuizCompletion";
    const response = await axiosRequest.post(url, { quizId });
    return response;
  },
  markAssignmentCompleted: async (assignmentId) => {
    const url = "AssignmentCompletion";
    const response = await axiosRequest.post(url, { assignmentId });
    return response;
  },
  getAllMyLearning: async (params) => {
    const url = "Course/Get-all-my-learning";
    const response = await axiosRequest.get(url, { params });
    return response;
  },
};

export { courseAPI };
